import React from "react";
import { ChevronDownIcon, UserIcon } from "lucide-react";
import { useOrg } from "../../../auth/org-provider";
import { UserDropdown } from "../org/user-dropdown";
import { PopoverTrigger } from "../../ui/popover";
import { UserAvatarAndName } from "../org/avatar-for-user";
import { cn } from "../../../lib/utils";

interface OwnerSelectorProps {
    ownerId: string | null;
    onOwnerChange: (ownerId: string | null) => void;
    label?: string;
    showChevron?: boolean;
}

export function OwnerSelector({ ownerId, onOwnerChange, label, showChevron }: OwnerSelectorProps) {
    const org = useOrg();

    return (
        <div className={"flex flex-row items-center gap-2 text-sm"}>
            {label && <div className={"font-medium text-muted-foreground"}>{label}</div>}
            <UserDropdown
                selected={ownerId ?? undefined}
                users={org.users}
                onSelect={(userId) => onOwnerChange(userId)}
                onUnselect={() => onOwnerChange(null)}
            >
                <PopoverTrigger>
                    <div
                        className={cn(
                            "flex cursor-pointer flex-row items-center gap-2 rounded-md px-2 py-1.5 transition-all hover:bg-input",
                            !ownerId && "bg-accent"
                        )}
                    >
                        {!ownerId && (
                            <div className={"flex flex-row items-center text-muted-foreground"}>
                                <UserIcon className={"me-1 h-4 w-4"} />
                                Select owner
                            </div>
                        )}
                        {ownerId && (
                            <UserAvatarAndName
                                avatarFallback={"icon"}
                                userId={ownerId}
                                avatarClassName={"w-5 h-5"}
                                nameClassName={"font-medium"}
                            />
                        )}
                        {showChevron && <ChevronDownIcon className={"h-3 w-3 text-muted-foreground"} />}
                    </div>
                </PopoverTrigger>
            </UserDropdown>
        </div>
    );
}
